const PDF_TEXT_COLUMNIZER_SCRIPT = `
  const BODY_PADDING_PX = 50;
  const COLUMN_GAP_PX = BODY_PADDING_PX;
  const GUTTER_MARGIN_PX = 15;

  function columnizeContent({ pageHeightPx, pageWidthPx }) {
    const header = document.querySelector("header");
    const article = document.querySelector("article");
    const footer = document.querySelector("footer");

    // next up, extract configurations
    const columnCount =
      parseInt(article.getAttribute("data-column-count") || "1", 10) || 1;
    const lineCountInterval =
      parseInt(article.getAttribute("data-line-interval") || "0", 10) || 0;

    const style = window.getComputedStyle(article);
    const fontSizePx = parseInt(style.fontSize, 10);
    const lineHeightPx = parseInt(style.lineHeight, 10);

    // limit the size of the viewport to the printed size
    document.body.style.width = \`\${pageWidthPx}px\`;

    // now calculate the number of lines we need to render in order to fit the
    // entire piece of content
    let lineCount = 0;
    let gutterWidth = 0;

    if (lineCountInterval) {
      article.style.width = \`calc((100% - \${
        (columnCount - 1) * COLUMN_GAP_PX
      }px) / \${columnCount})\`;

      // guess at the number of lines rendered based on current configuration
      lineCount = Math.ceil(article.offsetHeight / lineHeightPx);
      gutterWidth = \`\${
        (Math.floor(lineCount / 5) * 5).toString().length
      }ex\`;
      article.style.paddingLeft = \`calc(\${gutterWidth} + \${GUTTER_MARGIN_PX}px)\`;

      // second-guess the number of lines rendered based on the size after
      // adjusting for line number gutter
      lineCount = Math.ceil(article.offsetHeight / lineHeightPx);
      gutterWidth = \`\${
        (Math.floor(lineCount / 5) * 5).toString().length
      }ex\`;
      article.style.paddingLeft = \`calc(\${gutterWidth} + \${GUTTER_MARGIN_PX}px)\`;
    }

    // create even padding for header and first line of text
    let headerHeight = 0;

    if (header) {
      header.style.paddingLeft = \`calc(\${gutterWidth} + \${GUTTER_MARGIN_PX}px)\`;
      headerHeight = header.offsetHeight;
    }

    // limit the size of the viewport to reflect gutter width on both sides of
    // the content
    document.body.style.width = \`calc(\${pageWidthPx}px - \${gutterWidth} - \${GUTTER_MARGIN_PX}px)\`;

    // now inject the line gutter into the article, so that the line count
    // will be rendered nicely on the side of the content
    if (lineCountInterval) {
      // iterate over the first word on every single line, and begin inserting
      // line counters as needed
      const firstWordOnNumeratedLines = [];
      let lineNumber = 0;

      for (const firstWordOnLine of getFirstWordOnEveryLine(article)) {
        lineNumber++;

        if (lineNumber % lineCountInterval === 0) {
          firstWordOnNumeratedLines.push(firstWordOnLine);
        }
      }

      // iterate over the list of numerated lines, and insert line counter on
      // each one of them (we do this after the lines were counted, as the
      // process of injecting nodes into the DOM could otherwise slightly throw
      // off indexing in the previous step)
      const baselineOffset = Math.min(
        ...firstWordOnNumeratedLines.map(
          (word) => word.getBoundingClientRect().left
        )
      );

      firstWordOnNumeratedLines.map(
        (firstWordOnNumeratedLine, numeratedLineIndex) => {

          const bbox = firstWordOnNumeratedLine.getBoundingClientRect();

          // create line number indicator
          const lineNumber = document.createElement("span");
          lineNumber.className = "line-gutter";

          // In case the current word has been indented, then ensure that it is
          // flush with the column
          if (baselineOffset < bbox.left) {
            lineNumber.style.transform = \`translateX(-\${
              bbox.left - baselineOffset
            }px)\`;
          }

          lineNumber.appendChild(
            document.createTextNode(
              (numeratedLineIndex + 1) * lineCountInterval
            )
          );

          return [firstWordOnNumeratedLine, lineNumber];
        }
      ).forEach(([firstWordOnNumeratedLine, lineNumber]) => {
        // defer injection of the line numbers until after calculations have
        // been made to avoid layout thrashing
        firstWordOnNumeratedLine.style.position = "relative";
        firstWordOnNumeratedLine.appendChild(lineNumber);
      });
    }

    // re-configure article to fill up the entire width of the page again, and
    // apply columnization
    article.style.width = \`100%\`;
    article.style.columnCount = columnCount;
    article.style.columnGap = \`calc(\${COLUMN_GAP_PX}px + \${gutterWidth} + \${GUTTER_MARGIN_PX}px)\`;

    // finally force the content to fill the columns on the last page like a
    // usual print output
    const pageCount = Math.ceil(
      (headerHeight + article.offsetHeight) / pageHeightPx
    );
    // article.style.minHeight = \`\${pageCount * pageHeightPx - headerHeight}px\`;

    // and now apply the same logic to the footer, so that we can ensure that
    // it's columns are also rendered as expected
    if (footer) {
      footer.style.columnGap = \`\${COLUMN_GAP_PX}px\`;
    }

    // register that the content is now ready for layout to a PDF
    window.gExportServiceReady = true;
  }

  function* getFirstWordOnEveryLine(article) {
    const range = document.createRange();

    //
    // STEP: break text nodes into individual words
    //
    // create a clone of the article which is retained in-memory to avoid
    // costly reflows, and then break all text nodes in a way that allows
    // us to easily detect each individual words in the subsequent step by
    // walking over text nodes
    //

    const articleFragment = document.createDocumentFragment();
    articleFragment.appendChild(article);

    const nodeIterator = document.createNodeIterator(
      article,
      NodeFilter.SHOW_TEXT
    );

    // using the node iterator, break all text nodes into one node per word
    // (assuming that whitespace is always a word boundary)
    let nextNode;
    while ((nextNode = nodeIterator.nextNode())) {
      if (nextNode.parentElement.classList.contains("line-gutter")) {
        continue;
      }

      let match = nextNode.nodeValue.match(/[^\\s]+\\s/);

      while (match) {
        nextNode = nextNode.splitText(match.index + match[0].length);
        match = nextNode.nodeValue.match(/[^\\s]+\\s/);
      }
    }

    //
    // STEP: wrap all text nodes in <span>-elements, so that we can
    // determine their offsets on the y-axis (which is the heuristic used
    // to identify the first word on each line)
    //

    const nodeIteratorPass2 = document.createNodeIterator(
      article,
      NodeFilter.SHOW_TEXT
    );

    const wordTextNodes = [];
    const wordSpanNodes = [];

    while ((nextNode = nodeIteratorPass2.nextNode())) {
      if (
        !nextNode.nodeValue.trim() ||
        nextNode.parentElement.classList.contains("line-gutter")
      ) {
        continue;
      }

      wordTextNodes.push(nextNode);
    }

    for (const textNode of wordTextNodes) {
      const spanNode = document.createElement("span");

      textNode.parentNode.insertBefore(spanNode, textNode);
      spanNode.appendChild(textNode);

      wordSpanNodes.push(spanNode);
    }

    document.querySelector("div[data-article-root]").appendChild(article);

    //
    // STEP: finally iterate over all word nodes, and determine the first
    // word on each new line
    //

    let previousLineOffset = undefined;

    for (const word of wordSpanNodes) {
      const offset = word.getBoundingClientRect().top;

      if (previousLineOffset === undefined || previousLineOffset < offset) {
        yield word;
        previousLineOffset = offset;
      }
    }
  }

  columnizeContent({
    pageHeightPx: window.innerHeight,
    pageWidthPx: window.innerWidth - BODY_PADDING_PX * 2,
  });
`;
const PDF_RICHTEXT_COLUMNIZER_SCRIPT = `
  const BODY_PADDING_PX = 50;
  const COLUMN_GAP_PX = BODY_PADDING_PX;

  function columnizeContent({
    pageHeightPx,
    pageWidthPx,
  }) {
    const footer = document.querySelector("footer");

    // and now apply the same logic to the footer, so that we can ensure that
    // it's columns are also rendered as expected
    if (footer) {
      footer.style.columnGap = \`\${COLUMN_GAP_PX}px\`;
    }

    // register that the content is now ready for layout to a PDF
    window.gExportServiceReady = true;
  }

  columnizeContent({
    pageHeightPx: window.innerHeight,
    pageWidthPx: window.innerWidth - BODY_PADDING_PX * 2,
  });
`;

export { PDF_RICHTEXT_COLUMNIZER_SCRIPT, PDF_TEXT_COLUMNIZER_SCRIPT };
//# sourceMappingURL=pdfColumnizerScript.js.map
